export function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}

export function isNotNull<T>(value: T | null): value is T {
  return value !== null;
}

export function isNotEmpty<T>(value: T | undefined | null): value is T {
  return value !== null && value !== undefined;
}
